import React, { useEffect, useState } from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { OfferForm } from "../../UI/Offer/Add/OfferForm";
import { Helper } from "../../tools/Helper";
import { api_Routes } from "../../tools/api_Routes";
import { LinearProgress } from "@mui/material";

const OfferAdd = () => {
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getServices = async () => {
    setIsLoading(true);
    const { response } = await Helper.Get({
      url: api_Routes.Services.View,
      hasToken: true,
    });
    if (response) {
      setServices(response?.data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getServices();
  }, []);

  return (
    <div>
      <PanelHead title="Add Offer" />
      <PanelBody
        content={
          isLoading ? <LinearProgress /> : <OfferForm services={services} />
        }
      />
    </div>
  );
};

export default React.memo(OfferAdd);
